<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <!-- <a class="shop-hero-section cf" href="{{banneraddList?.url}}" target="_blank" [ngStyle]="{'background-image':'url(' + banneraddList?.file + ')'}">
        <div class="container">
            <div class="shop-hero-detail">
                <h3>buy match <br>day merchandise</h3>
            </div>
        </div>
    </a> -->
    <div class="shop-lccc-club-section cf">
        <div class="container">
            <div class="shop-lccc-club-detail">
                <div class="titel-box">
                    <h2 class="titel-name">LCCC Club Shop</h2>
                </div>
                <div class="shop-lccc-club-main">
                    <div class="shop-lccc-club-box"  *ngFor="let product of productList?.data">
                        <a [routerLink]="['/shop', product?.slug]">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img" *ngIf="product?.image">
                                    <img [src]="product?.image">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>{{product?.title}} </h3>
                                <p *ngIf="product?.amount">{{product?.amount | currency:'&#163;' }}</p>
                            </div>
                        </a>
                    </div>
                    <!-- <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img2.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>A3 Calendar</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img3.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Desk Calendar</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img4.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Notepad and Pen </h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img5.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Coffee Cups</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img6.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Umbrella</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img7.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Premium Pen</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img8.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Year Book</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img9.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Gift Cards</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div>
                    <div class="shop-lccc-club-box">
                        <a href="#">
                            <div class="shop-lccc-club-box-inner">
                                <div class="shop-lccc-club-box-inner-img">
                                    <img src="assets/images/shop-img10.png">
                                </div>
                            </div>
                            <div class="shop-lccc-club-box-content">
                                <h3>Bobble Hats</h3>
                                <p>£10.00</p>
                            </div>
                        </a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    
</section><!-- page ends-->